import copy from '../../../assets/copiar.png'
import copyImage from '../../../assets/copiar_gris.png'
import paste from '../../../assets/pegar.png'
import pasteImage from '../../../assets/pegar_gris.png'
export const dictionary = {
  cantCopy: copyImage,
  canCopy: copy,
  canPaste: paste,
  cantPaste: pasteImage,
}
export type PasteKeys = keyof typeof dictionary
export type CopyRecord = Record<string, Extract<PasteKeys, 'canCopy' | 'cantCopy'>>
export type PasteRecord = Record<string, Extract<PasteKeys, 'canPaste' | 'cantPaste'>>
